import { motion } from "framer-motion";
import { EASE } from "@/lib/site";

export default function Reveal({ children, delay = 0, className = "", y = 48 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10%" }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}
